let hash = window.location.hash
const anchorsList = document.getElementById('anchors-list')
const listNav = document.querySelectorAll('#anchors-list [data-anchor]');    



function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}



function jumpTo(hash) {
    const listNav = [...document.querySelectorAll('#anchors-list [data-anchor]')];
    listNav.forEach(element => {
      if ( element.dataset.anchor == hash.substr(1)) {
        element.classList.add('!bg-blue-200')
      } else {
        element.classList.remove('!bg-blue-200')
      }
    })
}

function navHighlighter() {      
    const scrollY = window.pageYOffset; 
    const sections = [...document.querySelectorAll("[data-scroll]")];
    const listNav = [...document.querySelectorAll('#anchors-list [data-anchor]')];

    sections.forEach(current => {
        const sectionId = current.getAttribute("id");    
        const sectionHeight = current.offsetHeight;  
        const sectionTop = (current.getBoundingClientRect().top + window.pageYOffset) - 190;
        const navItem = document.querySelector("#anchors-list [data-anchor=" + sectionId + "]")
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight){
            listNav.forEach(element => {
                if ( element.dataset.anchor == sectionId) {
                    element.classList.add('!bg-blue-200')
                    if(!isInViewport(element)){
                        anchorsList.scrollTo({
                            top: 0,
                            left: element.offsetLeft - (window.innerWidth / 2),
                            behavior: 'smooth'
                        });
                    }
                } else {
                    element.classList.remove('!bg-blue-200')
                }
            })
        } else {
            navItem.classList.remove("!bg-blue-200");
        }       
    });
}



  
  
window.addEventListener("DOMContentLoaded", () => {
    let hash = window.location.hash  

    listNav.forEach(element => {
        element.addEventListener('click', ()=> {
            let toGoElement = document.getElementById(element.dataset.anchor).offsetTop;        
            let headerHeight = document.getElementById('vue-header').offsetHeight
            let anchorsBarHeight = document.getElementById('anchors-bar').offsetHeight;
            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            let numberToAdd = 20

            if(isSafari){
                numberToAdd =  -10           
            } else if (isFirefox) {
                numberToAdd = -5                
            } else {
                numberToAdd = 20
            }
            window.scroll({
                top: toGoElement - (anchorsBarHeight + headerHeight ) + numberToAdd,
                left: 0,
                behavior: "smooth"
            });
        })
    })


    anchorsList && hash.length && jumpTo(hash) 

    anchorsList && window.addEventListener("scroll", navHighlighter)

    window.addEventListener("hashchange", ()=>{
        let hash = window.location.hash  
        jumpTo(hash)  
    });    
});